<template>
    <b-container fluid class="ds-top-body text-left">
        <div v-if="pageLoading" class="dimmed-loading">
            <div class="text-center">
                <b-spinner style="width: 3rem; height: 3rem"></b-spinner>
                <div class="mt-3 gray-700 f-120">
                    <div>
                        {{ loadingMsg.title }}
                    </div>
                    <div>
                        {{ loadingMsg.content }}
                    </div>
                </div>
            </div>
        </div>
        <div
            :style="is_printing === true ? 'position:absolute; margin-left:-9999px; margin-top:-9999px; width:1200px' : ''">
            <div id="campaign_report_container" :class="is_printing === true ? 'p-5' : ''">
                <!-- 인쇄 버튼 줄 — 바깥 본문(화면 폭)을 따라 표 오른쪽 끝선에 맞춘다 -->
                <b-container fluid class="px-0"
                    :class="is_loaded_companies_result === true ? 'text-right position-relative' : 'py-3 mb-1'">
                    <template v-if="is_loaded_companies_result === true">
                        <general-print-button print_target="campaign_report_container"
                                              :btn_variant="'subtop-gn'"
                                              :d_none="is_printing === true ? 'd-none' : ''"
                                              :file_title="`${admin_mode === 'project' ? (now_project.project_code || $route.query.pc) : campaign.campaign_name} 평가 결과`"
                                              @modal-opened="is_printing = true"
                                              @modal-closed="is_printing = false"
                        >
                            <fa icon="print"></fa>
                        </general-print-button>
                    </template>
                </b-container>
                <b-container v-if="is_printing === true" class="bgray-200 text-center py-3 mb-5">
                    <h3 class="f-160 py-5 mb-0"> {{ admin_mode === 'project' ? (now_project.project_code || $route.query.pc) : campaign.campaign_name }} 평가 결과</h3>
                </b-container>

                <div class="pt-4 mb-5 d-flex justify-content-between align-items-center">
                    <h4 class="fw-600"> 결과보고서 보기 </h4>

                    <!-- 액션 버튼 묶음: 성격이 비슷한 항목을 드롭다운으로 그룹화해 한 줄을 정돈한다.
                         자주 쓰는 '답변 충돌 확인'만 단독 버튼으로 밖에 두고, 나머지는
                         AI/팩트 · 보고서 · 업체/데이터 세 그룹으로 접는다. -->
                    <b-btn-group v-if="!is_printing">
                        <template v-if="is_admin >= 3">
                            <b-btn v-if="has_project_scope"
                                   class="f-90"
                                   size="sm"
                                   :disabled="is_bulk_ai_requesting || is_fact_batch_requesting"
                                   @click="checkIntegrity"
                            >
                                답변 충돌 확인
                            </b-btn>
                            <!-- AI / 팩트 프로젝트 단위 일괄 작업 -->
                            <b-dropdown v-if="show_ai_request_btn && admin_mode === 'project'"
                                        variant="success" size="sm" class="f-90"
                                        :disabled="is_bulk_ai_requesting || is_fact_batch_requesting"
                            >
                                <template #button-content>
                                    <b-spinner v-if="is_bulk_ai_requesting || is_fact_batch_requesting"
                                               style="width: 1.1rem; height: 1.1rem;"></b-spinner>
                                    <template v-else>AI / 팩트 일괄</template>
                                </template>
                                <b-dropdown-item :disabled="is_bulk_ai_requesting"
                                                 @click="checkRequestProjectAIAssessment('immediate')">
                                    AI 평가 일괄 요청 (즉시)
                                </b-dropdown-item>
                                <b-dropdown-item :disabled="is_bulk_ai_requesting"
                                                 @click="checkRequestProjectAIAssessment('batch')">
                                    AI 평가 일괄 요청 (배치)
                                </b-dropdown-item>
                                <b-dropdown-item :disabled="is_fact_batch_requesting"
                                                 @click="checkRequestProjectFactBatch">
                                    팩트 일괄 추출 (배치)
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item @click="goEvalProfileManagement">
                                    AI 평가 프로파일 관리
                                    <fa icon="external-link-alt" class="ml-1" style="font-size: 0.8em;"></fa>
                                </b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <template v-if="is_admin === 4">
                            <!-- 결과보고서 -->
                            <b-dropdown v-if="has_project_scope" variant="dark" size="sm" class="f-90" text="보고서">
                                <b-dropdown-item v-if="7724 == user_id || 78429 == user_id || user_id == 82849"
                                                 @click="$bvModal.show('modal-report-replacement')">
                                    결과보고서 교체기
                                </b-dropdown-item>
                                <b-dropdown-item @click="$bvModal.show('modal-project-report-bulk-generator')">
                                    결과보고서 생성기
                                </b-dropdown-item>
                                <b-dropdown-item @click="$bvModal.show('modal-project-report-bulk-submitter')">
                                    결과보고서 확정 &amp; 배포기
                                </b-dropdown-item>
                                <b-dropdown-item @click="$bvModal.show('modal-na-upgrade-exporter')">
                                    해당없음 격상 목록 출력
                                </b-dropdown-item>
                            </b-dropdown>
                            <!-- 업체 / 데이터 -->
                            <b-dropdown variant="outline-secondary" size="sm" class="f-90" text="업체 / 데이터">
                                <b-dropdown-item :disabled="selectedReopenTargets.length === 0 || is_bulk_reopening"
                                                 @click="$bvModal.show('modal-bulk-reopen-confirm')">
                                    <b-spinner v-if="is_bulk_reopening" style="width: 1.1rem; height: 1.1rem;"></b-spinner>
                                    <template v-else>
                                        선택 업체 보완중 전환<span v-if="selectedReopenTargets.length"> ({{ selectedReopenTargets.length }})</span>
                                    </template>
                                </b-dropdown-item>
                                <b-dropdown-item @click="$bvModal.show('modal-ecovadis-processor')">
                                    기업 에코바디스 처리기
                                </b-dropdown-item>
                                <template v-if="has_project_scope">
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-dropdown-item @click="$bvModal.show('modal-project-dataCenter')">
                                        데이터 다운로드 센터
                                    </b-dropdown-item>
                                </template>
                            </b-dropdown>
                        </template>
                    </b-btn-group>
                </div>

                <!-- 팩트(문서 사실) 추출 배치 현황 요약: 진입 시 1회 조회 + 수동 새로고침.
                     프로젝트 모드에서 대상 첨부가 있을 때만 노출한다(부가 정보라 실패해도 화면을 막지 않음). -->
                <div v-if="showFactBatchStatus"
                     class="d-flex align-items-center flex-wrap mb-2"
                >
                    <span class="small text-muted mr-2">팩트 추출:</span>
                    <b-badge variant="success" class="mr-1">완료 {{ factBatchStatus.done }}</b-badge>
                    <b-badge variant="info" class="mr-1">진행중 {{ factBatchStatus.in_progress }}</b-badge>
                    <b-badge variant="secondary" class="mr-1">대기 {{ factBatchStatus.queued }}</b-badge>
                    <b-badge variant="light" class="border text-dark mr-1">미추출 {{ factBatchStatus.pending }}</b-badge>
                    <b-badge v-if="factBatchStatus.failed" variant="danger" class="mr-1">실패 {{ factBatchStatus.failed }}</b-badge>
                    <b-btn size="sm" variant="link" class="p-0 ml-1"
                           :disabled="factStatusLoading"
                           title="현황 새로고침"
                           @click="loadProjectFactBatchStatus"
                    >
                        <b-spinner v-if="factStatusLoading" style="width: .9rem; height: .9rem;"></b-spinner>
                        <span v-else class="small">새로고침</span>
                    </b-btn>
                </div>

                <div v-if="!is_printing" class="d-flex flex-wrap align-items-center mb-2">
                    <b-form-input v-model="search_keyword"
                                  debounce="300"
                                  size="sm"
                                  placeholder="기업명 또는 기업 ID 검색"
                                  class="mr-3"
                                  style="max-width: 280px;"
                    />
                    <div v-if="is_admin === 4 && selectedReopenTargets.length" class="d-flex align-items-center">
                        <span class="f-90 mr-2">선택 {{ selectedReopenTargets.length }}개</span>
                        <b-btn size="sm" variant="primary" :disabled="is_bulk_reopening"
                               @click="$bvModal.show('modal-bulk-reopen-confirm')">
                            <b-spinner v-if="is_bulk_reopening" small class="mr-1"></b-spinner>
                            보완중 전환
                        </b-btn>
                    </div>
                </div>

                <!-- DS 표 규칙: 행 44 고정 — 칸마다 한 줄, 넘치면 줄이고 전체는 title(툴팁). 폭은 머리가 정하고(ds-table-fixed)
                     폭을 안 적은 기업 · 프로젝트 열이 남는 폭을 나눠 갖는다. 대체평가는 대체 쪽을 보이고 원래 기업 · 코드는 title 로 -->
                <b-table-simple hover responsive class="mb-3"
                                :table-class="['ds-table', 'ds-table-fixed', 'campaign-report-table', { 'is-printing': is_printing }]">
                    <b-thead>
                        <b-tr>
                            <!-- 보완중 일괄 전환 고르기(DS 표 맨 앞 «고르는» 열 48) — 관리자 4, 인쇄 때는 없음 -->
                            <b-th v-if="is_admin === 4 && !is_printing" class="text-center" style="width: 48px;">
                                <b-form-checkbox
                                    :checked="allReopenableSelected"
                                    :disabled="reopenableKeys.length === 0"
                                    class="d-inline-block"
                                    aria-label="보완중 전환 대상 모두 선택"
                                    @change="toggleSelectAllReopen"
                                />
                            </b-th>
                            <b-th class="ds-cell-no" style="width: 56px;">No.</b-th>
                            <b-th style="width: 96px;">진행</b-th>
                            <b-th>기업</b-th>
                            <b-th>프로젝트 / 캠페인</b-th>
                            <b-th class="ds-cell-num" style="width: 72px;">총점</b-th>

                            <b-th v-for="(scoreCategory1_name, scoreCategory1_idx) in scoreCategory1"
                                  :key="`scoreCategory1-${scoreCategory1_idx}`"
                                  class="ds-cell-num"
                                  style="width: 72px;"
                            >
                                {{ scoreCategory1_name }}
                            </b-th>

                            <template v-if="is_admin >= 3">
                                <b-th style="width: 88px;">평가유형</b-th>
                                <b-th style="width: 80px;">종합의견</b-th>
                            </template>
                            <b-th v-if="!is_printing" :style="{ width: is_admin >= 3 ? '220px' : '64px' }">
                                <span class="sr-only">작업</span>
                            </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <template v-if="!is_loaded_companies_result">
                            <b-tr v-for="n in 40" :key="`project_code-skeleton-list-${n}`">
                                <b-td v-for="col in table_col_count" :key="col">
                                    <b-skeleton></b-skeleton>
                                </b-td>
                            </b-tr>
                        </template>
                        <b-tr v-else-if="results_error">
                            <b-td :colspan="table_col_count" class="p-0">
                                <PageEmptyComponent compact :error="results_error" @retry="getCompaniesAssessmentResult(true)"/>
                            </b-td>
                        </b-tr>
                        <b-tr v-else-if="filteredCompaniesResults.length === 0">
                            <b-td :colspan="table_col_count" class="text-center gray-600 py-4">
                                {{ search_keyword ? '검색 결과가 없습니다.' : '조회된 기업이 없습니다.' }}
                            </b-td>
                        </b-tr>
                        <template v-else>
                            <b-tr v-for="(company, idx) in filteredCompaniesResults"
                                  :key="`company-result-${company.company_id}`">
                                <b-td v-if="is_admin === 4 && !is_printing" class="text-center">
                                    <b-form-checkbox
                                        v-if="isReopenable(company)"
                                        v-model="selectedReopenKeys"
                                        :value="keyOf(company)"
                                        class="d-inline-block"
                                        :aria-label="`${company.company_name} 보완중 전환 대상`"
                                    />
                                </b-td>
                                <b-td class="ds-cell-no">{{ idx + 1 }}</b-td>

                                <b-td>
                                    <span class="ds-status" :class="`ds-status-${getProgressTone(company.priority || company)}`">
                                        {{ getProgressStatusLabel(company.priority || company) }}
                                    </span>
                                </b-td>

                                <b-td>
                                    <span class="ds-ellipsis"
                                          :title="company.priority
                                              ? `대체 ${company.priority.company_name}(${company.priority.company_id}) ← 원래 ${company.company_name}(${company.company_id})`
                                              : `${company.company_name}(${company.company_id})`">
                                        <span v-if="company.priority" class="ds-tag mr-1">대체</span>{{ (company.priority || company).company_name }} <span class="ds-sub">{{ (company.priority || company).company_id }}</span>
                                        <span v-if="is_printing && company.priority" class="ds-sub ml-1">← 원래 {{ company.company_name }} {{ company.company_id }}</span>
                                    </span>
                                </b-td>

                                <b-td>
                                    <span class="ds-ellipsis"
                                          :title="company.priority
                                              ? `대체 ${company.priority.project_code} · ${company.priority.campaign_id} ← 원래 ${company.project_code} · ${company.campaign_id}`
                                              : `${company.project_code} · ${company.campaign_id}`">
                                        {{ (company.priority || company).project_code }} <span class="ds-sub">{{ (company.priority || company).campaign_id }}</span>
                                        <span v-if="is_printing && company.priority" class="ds-sub ml-1">← 원래 {{ company.project_code }} {{ company.campaign_id }}</span>
                                    </span>
                                </b-td>

                                <template
                                    v-if="company.total_score !== null || (company.priority && company.priority.total_score !== null)">
                                    <b-td class="ds-cell-num">
                                        {{ roundToOneDecimalPlace((company.priority || company).total_score) }}
                                    </b-td>

                                    <b-td v-for="(category1_name) in scoreCategory1"
                                          :key="`${company.company_id}-category1-score-${category1_name}-score`"
                                          class="ds-cell-num"
                                    >
                                        {{
                                            (company.priority || company).category1_scores == null ? ' - ' : (company.priority || company).category1_scores[scoreMapCategory1[category1_name]] === -1 ? 'N/A' : roundToOneDecimalPlace((company.priority || company).category1_scores[scoreMapCategory1[category1_name]])
                                        }}
                                    </b-td>
                                </template>
                                <template v-else>
                                    <b-td class="ds-cell-num">-</b-td>
                                    <b-td class="ds-cell-num">-</b-td>
                                    <b-td class="ds-cell-num">-</b-td>
                                    <b-td class="ds-cell-num">-</b-td>
                                </template>

                                <template v-if="is_admin >= 3">
                                    <b-td>
                                        <span v-if="!(company.priority || company).service_type" class="ds-sub">-</span>
                                        <button v-else
                                                type="button"
                                                class="ds-tag"
                                                :class="{ 'ds-tone-danger': (company.priority || company).service_type === '심화' }"
                                                :title="`눌러서 일반/심화 전환${company.priority ? ' (대체 상태)' : ''}`"
                                                @click="updateServiceType(company)"
                                        >
                                            <b-spinner v-if="is_service_types_updating === company.company_id" small/>
                                            <template v-else>{{ (company.priority || company).service_type }}</template>
                                        </button>
                                    </b-td>

                                    <b-td>
                                        <span v-if="company.audit_status || (company.priority && company.priority.audit_status)"
                                              class="ds-status ds-status-success">완료</span>
                                        <span v-else class="ds-sub">-</span>
                                    </b-td>
                                </template>

                                <!-- 행 작업(아이콘 28): 답변보기 · 결과보고서 관리 · AI 평가용 자료 · 보완검토 · AI 평가 · 더보기(덜 쓰는 것) -->
                                <b-td v-if="!is_printing">
                                    <div class="d-flex justify-content-end" style="gap: 4px">
                                        <button type="button" class="ds-row-icon-btn"
                                                :aria-label="`${(company.priority || company).company_name} 답변보기`" title="답변보기"
                                                @click="goCompanyAnswers(company)">
                                            <AppIcon name="list-details"/>
                                        </button>
                                        <template v-if="is_admin >= 3">
                                            <button type="button" class="ds-row-icon-btn"
                                                    :aria-label="`${(company.priority || company).company_name} 결과보고서 관리`" title="결과보고서 관리"
                                                    @click="openManagingCompanyReportModal(company)">
                                                <AppIcon name="file-text"/>
                                            </button>
                                            <button type="button" class="ds-row-icon-btn"
                                                    :disabled="downloading_packet_id === company.company_id"
                                                    :aria-label="`${(company.priority || company).company_name} AI 평가용 자료 다운로드`" title="AI 평가용 자료 다운로드"
                                                    @click="downloadEvaluationPacket(company)">
                                                <b-spinner v-if="downloading_packet_id === company.company_id" small/>
                                                <AppIcon v-else name="download"/>
                                            </button>
                                            <button type="button" class="ds-row-icon-btn"
                                                    :aria-label="`${(company.priority || company).company_name} AI 보완검토 (새 탭에서 열림)`" title="AI 보완검토 (새 탭에서 열림)"
                                                    @click="goSupplementReview(company)">
                                                <AppIcon name="external-link"/>
                                            </button>
                                            <b-dropdown v-if="show_ai_request_btn"
                                                        variant="link" no-caret right
                                                        toggle-class="ds-row-icon-btn"
                                                        :toggle-attrs="{ 'aria-label': `${(company.priority || company).company_name} AI 평가 요청`, title: 'AI 평가 요청' }"
                                                        :disabled="is_bulk_ai_requesting"
                                            >
                                                <template #button-content>
                                                    <AppIcon name="sparkles"/>
                                                </template>
                                                <b-dropdown-item class="f-90"
                                                                 @click="checkRequestAIAssessment(company, 'immediate')">
                                                    AI 평가 요청 (즉시)
                                                </b-dropdown-item>
                                                <b-dropdown-item class="f-90"
                                                                 @click="checkRequestAIAssessment(company, 'batch')">
                                                    AI 평가 요청 (배치)
                                                </b-dropdown-item>
                                            </b-dropdown>
                                            <!-- 더보기: 예전 답변보기 메뉴의 집계값 · 상태변경 칸 — 권한 · 표시 조건 그대로 -->
                                            <b-dropdown v-if="is_admin === 4 || canForceSubmit(company) || canEditAnswer(company)"
                                                        variant="link" no-caret right
                                                        toggle-class="ds-row-icon-btn"
                                                        :toggle-attrs="{ 'aria-label': `${(company.priority || company).company_name} 더보기`, title: '더보기' }"
                                            >
                                                <template #button-content>
                                                    <AppIcon name="dots-vertical"/>
                                                </template>
                                                <b-dropdown-item v-if="is_admin === 4" class="f-90"
                                                                 @click="downloadAnswerAggregationsByCompany(company)">
                                                    답변 집계값 다운로드
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="canForceSubmit(company)" class="f-90"
                                                                 :disabled="is_admin !== 4 || is_force_submitting"
                                                                 @click="submitAnswerByQesg(company)">
                                                    임의제출<template v-if="company.priority"> (대체 수정)</template>
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="canEditAnswer(company)" class="f-90"
                                                                 :disabled="is_admin !== 4"
                                                                 @click="backToInProgress(company)">
                                                    답변수정<template v-if="company.priority"> (대체 수정)</template>
                                                </b-dropdown-item>
                                            </b-dropdown>
                                            <span v-else class="ds-row-icon-btn" aria-hidden="true"></span>
                                        </template>
                                    </div>
                                </b-td>
                            </b-tr>
                        </template>
                    </b-tbody>
                </b-table-simple>

                <!-- 결과보고서 관리 ~ New -->
                <b-modal id="modal-bulk-reopen-confirm"
                         title="보완중 일괄 전환 확인"
                         centered
                         ok-variant="primary"
                         ok-title="전환"
                         cancel-title="취소"
                         @ok="performBulkReopen"
                >
                    <p class="mb-2">
                        선택한 <strong>{{ selectedReopenTargets.length }}개</strong> 업체를 모두 '보완중'으로 전환합니다.
                    </p>
                    <ul class="mb-2 pl-4 f-90 overflow-auto" style="max-height: 200px;">
                        <li v-for="target in selectedReopenTargets" :key="keyOf(target)">
                            {{ target.priority ? `[대체] ${target.priority.company_name}` : target.company_name }}
                        </li>
                    </ul>
                    <p v-if="selectedSubstituteCount > 0" class="mb-2 text-secondary">
                        - 대체평가 포함: <strong>{{ selectedSubstituteCount }}개</strong>
                        <span class="d-block ml-3 f-90">(대체코드가 보완중으로 전환됩니다)</span>
                    </p>
                    <p class="mb-0 text-danger f-90">
                        전환 시 해당 업체의 <strong>모든 문항</strong>이 다시 답변 가능(재작성) 상태가 됩니다.
                    </p>
                </b-modal>

                <b-modal id="managing-report"
                         :title="`${report_managing_company.company_name}: 결과보고서 미리보기 및 관리`"
                         size="xl"
                         body-bg-variant="white"
                         body-class="report-modal-body"
                         hide-footer
                         centered
                         :no-close-on-backdrop="preventCloseReportModal"
                         :no-close-on-esc="preventCloseReportModal"
                >
                    <ManagingResultReportV2 v-if="report_management_version === 'v2'"
                                            v-bind="{ ...report_managing_company }"
                                            @update-release="getCompaniesAssessmentResult"
                                            @prevent-close-report-modal="(_state) => preventCloseReportModal = _state"
                    />
                    <ManagingResultReport v-else
                                          v-bind="{ ...report_managing_company }"
                                          @update-release="getCompaniesAssessmentResult"
                                          @prevent-close-report-modal="(_state) => preventCloseReportModal = _state"
                    />
                </b-modal>

                <b-modal id="modal-report-replacement"
                         :title="`${now_project.project_code || $route.query.pc} - 결과보고서 교체`"
                         size="xl"
                         body-bg-variant="white"
                         hide-footer
                         centered
                         :no-close-on-backdrop="preventCloseReplacementModal"
                         :no-close-on-esc="preventCloseReplacementModal"
                         :hide-header-close="preventCloseReplacementModal"
                >
                    <ReplacementReport @prevent-close-replacement-modal="(_state) => preventCloseReplacementModal = _state"></ReplacementReport>
                </b-modal>


                <b-modal id="modal-project-dataCenter"
                         :title="`${now_project.project_code || $route.query.pc} - 평가 관련 데이터 센터`"
                         size="xl"
                         body-bg-variant="white"
                         body-class="report-modal-body"
                         hide-footer
                         centered
                         :no-close-on-backdrop="preventCloseDataCenterModal"
                         :no-close-on-esc="preventCloseDataCenterModal"
                >
                    <ProjectDataCenter ref="projectDataCenterRef"
                                       :project-company="companiesResults"
                                       @prevent-close-dataCenter-modal="(_state) => preventCloseDataCenterModal = _state"
                                       @checkIntegrity="checkIntegrity"
                    />
                </b-modal>

                <b-modal id="modal-project-report-bulk-submitter"
                         title="결과보고서 확정 & 배포기"
                         size="xl"
                         body-bg-variant="white"
                         body-class="report-modal-body"
                         hide-footer
                         centered
                         no-close-on-backdrop
                         no-close-on-esc
                         :hide-header-close="preventCloseSubmitterModal"
                >
                    <ReportBulkSubmitter @prevent-close-submitter-modal="(_state) => preventCloseSubmitterModal = _state"/>
                </b-modal>

                <b-modal id="modal-project-report-bulk-generator"
                         title="결과보고서 생성기"
                         size="xl"
                         body-bg-variant="white"
                         body-class="report-modal-body"

                         hide-footer
                         :no-close-on-backdrop="preventCloseGeneratorModal"
                         :no-close-on-esc="preventCloseGeneratorModal"
                         :hide-header-close="preventCloseGeneratorModal"
                         centered
                >
                    <ReportBulkGenerator ref="reportBulkGeneratorRef"
                                         @update-release="getCompaniesAssessmentResult"
                                         @prevent-close-generator-modal="(_state) => preventCloseGeneratorModal = _state"
                    />
                </b-modal>
                <b-modal id="modal-ecovadis-processor"
                         title="에코바디스 처리기"
                         size="xl"
                         body-bg-variant="white"
                         body-class="report-modal-body"
                         hide-footer
                         centered
                >
                    <ecovadis-processor :project-company="companiesResults"
                                        @updateProjectCompany="getCompaniesAssessmentResult(true)"
                    />
                </b-modal>
                <b-modal id="modal-na-upgrade-exporter"
                         title="해당없음 격상 목록 출력"
                         size="lg"
                         body-bg-variant="white"
                         body-class="report-modal-body"
                         hide-footer
                         centered
                >
                    <NaUpgradeExporter/>
                </b-modal>
            </div>
        </div>
        <hr class="border-0 my-5 py-5">
    </b-container>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import {mapActions, mapState, mapMutations} from 'vuex';
import PageEmptyComponent from '@shared_components/admin/components/common/PageEmptyComponent.vue';
import AssessmentCommonMixin from '@shared_mixins/assessment.common.mixin.js';
import downloadFile from '@shared_mixins/downloadFile';
import GeneralPrintButton from '@shared_components/admin/components/common/GeneralPrintButton';
import ManagingResultReport from '@shared_components/admin/components/managing/ManagingResultReport';
import ProjectDataCenter from '@shared_components/admin/components/managing/ProjectDataCenter';
import ReportBulkGenerator from '@shared/components/admin/components/report/ReportMamagement/ReportBulkGenerator.vue';
import ReportBulkSubmitter from '@shared/components/admin/components/report/ReportMamagement/ReportBulkSubmitter.vue';
import ReplacementReport from '@shared/components/admin/components/report/ReportMamagement/ReplacementReport.vue';
import EcovadisProcessor from '@shared/components/admin/components/managing/EcovadisProcessor.vue';
import NaUpgradeExporter from '@shared/components/admin/components/report/ReportMamagement/NaUpgradeExporter.vue';
import {checkAppEnv} from '@shared/utils/common';
import {runConfirmedDispatch} from '@shared/utils/aiAuditDispatch';
import {tenant} from '@shared/utils/tenant';
import {resolveReportTemplate, REPORT_RENDERERS} from '@shared_mixins/report/report-template';
import {checkCanRequestAi} from '@shared/components/admin/pages/Management/AIAssessment/data';
import ManagingResultReportV2 from '@shared/components/admin/components/managing/ManagingResultReport_v2.vue';

export default {
    name: 'CampaignReport',
    components: {
        PageEmptyComponent,
        ManagingResultReportV2,
        EcovadisProcessor,
        NaUpgradeExporter,
        GeneralPrintButton,
        ManagingResultReport,
        ReportBulkGenerator,
        ProjectDataCenter,
        ReportBulkSubmitter,
        ReplacementReport
    },
    mixins: [
        AssessmentCommonMixin,
        downloadFile,
    ],
    data() {
        return {
            en: false,
            // in_assessment:false,
            // audit_completed: {},
            // check:{},
            is_printing: false,
            preventCloseReportModal: false,

            downloading_raw_data: false,
            // downloading_evaluation: false,

            result_report_mode: '',

            upload_file: null,
            upload_modal_selected_company_id: null,
            is_uploading: false,
            upload_modal_selected_company_name: null,
            nice_permit_required: true,
            release_target_company: null,
            // logo_mode: 'QESG',
            // report_summary: false,
            default_report_list: [
                {name: '현대자동차 결과보고서', code: 'hd_full', icon: 'file-contract', description: '현대자동차 ESG 평가 결과보고서'}
            ],
            no_rating: false,
            company_status: '',
            isReportGenerating: {
                hd_full: false,
                hd_full_2: false,
                hd_full_3: false
            },
            service_types: [],
            is_service_types_updating: false,
            selected_service_type: '일반',

            // 기업별 AI 평가용 자료(문항+첨부) ZIP 다운로드 진행 중인 행의 company_id (중복 클릭 방지 + 스피너)
            downloading_packet_id: null,

            // Newer
            reportData: {
                info: null,
                benchmarks: null,
                parser: null,
                risk: null,
                scoring: null
            },
            is_loaded_companies_result: false,
            results_error: '',
            companiesResults: [],
            // 보완중 일괄 전환: 선택된 행의 키(effective identity) 배열 + 진행 플래그
            selectedReopenKeys: [],
            is_bulk_reopening: false,
            report_managing_company: {
                project_code: null,
                campaign_id: null,
                campaign_name: null,
                company_id: null,
                company_name: null,
                period: null,
                request_id: null,
                requested_e_mail: null,
                service_type: null,
                status_code: null,
                audit_status: null,
            },
            preventCloseDataCenterModal: false,

            // 결과보고서 교체 모달
            preventCloseReplacementModal: false,

            // 결과보고서 배포 모달
            preventCloseSubmitterModal: false,

            // 결과보고서 생성 모달
            preventCloseGeneratorModal: false,

            // 임의제출 요청 중 (중복 클릭 방지)
            is_force_submitting: false,
            force_submit_noti: false,

            // AI 평가 프로젝트 단위 일괄 요청 진행 플래그 (중복 클릭 방지)
            is_bulk_ai_requesting: false,
            // 팩트(문서 사실) 프로젝트 단위 일괄 추출 진행 플래그 (중복 클릭 방지)
            is_fact_batch_requesting: false,
            // 팩트 배치 현황 요약 (진입 시 1회 조회 + 수동 새로고침). null = 아직 미조회.
            factBatchStatus: null,
            factStatusLoading: false,

            pageLoading: false,
            loadingMsg: {
                title: 'AI 평가 요청 중',
                content: '잠시만 기다려주세요...'
            }
        };
    },
    computed: {
        ...mapState(['user_id', 'campaign', 'admin_mode']),
        ...mapState('industry_campaigns', ['history_scores', 'is_history_score_loaded']),
        ...mapState('industry_scores', ['industry_info', 'category1s', 'risk_lv']),
        ...mapState('score', ['temp_target_companies']),
        ...mapState('project_code', ['now_project', 'project_companies', 'is_project_companies_loaded']),
        ...mapState('admin', ['sub_layout_loading']),
        is_admin() {
            return Number(this.$store.getters.isAdmin);
        },
        // 검색어는 ?q= (답변보기 등 다녀와도 유지, 탭 이동 시에는 빠진다)
        search_keyword: {
            get() {
                return typeof this.$route.query.q === 'string' ? this.$route.query.q : '';
            },
            set(value) {
                const q = value || undefined;
                if (q === this.$route.query.q) return;
                this.$router.replace({query: {...this.$route.query, q}}).catch(() => {});
            }
        },
        // 기업명·기업 ID(대체평가 업체 포함)로 거른 표 행
        filteredCompaniesResults() {
            const keyword = this.search_keyword.trim().toLowerCase();
            if (!keyword) return this.companiesResults;
            return this.companiesResults.filter(c => [c.company_name, c.company_id, c.priority?.company_name, c.priority?.company_id]
                .some(v => v != null && String(v).toLowerCase().includes(keyword)));
        },
        // '보완중' 일괄 전환 대상(= '답변수정' 버튼 노출 조건과 동일) 중 지금 표에 보이는 행의 키 목록
        reopenableKeys() {
            return this.filteredCompaniesResults
                .filter(c => this.isReopenable(c))
                .map(c => this.keyOf(c));
        },
        // 헤더 전체선택 체크 상태 (대상이 하나라도 있고, 모두 선택돼 있으면 true)
        allReopenableSelected() {
            const keys = this.reopenableKeys;
            return keys.length > 0 && keys.every(k => this.selectedReopenKeys.includes(k));
        },
        // 현재 선택된(그리고 여전히 대상인) 행들 — 스테일 키는 자동 제외
        // 팩트 배치 현황 배지 노출 조건: 프로젝트 모드 + 조회됨 + 대상 첨부가 하나라도 있을 때.
        // 프로젝트 단위 도구(보고서 생성/배포/교체, 데이터 센터, 답변 충돌 확인)는 project_code 가 있을 때만 연다
        has_project_scope() {
            return this.admin_mode === 'project' && !!(this.now_project.project_code || this.$route.query.pc);
        },
        showFactBatchStatus() {
            return this.admin_mode === 'project'
                && !!this.factBatchStatus
                && this.factBatchStatus.total > 0;
        },
        selectedReopenTargets() {
            return this.companiesResults.filter(
                c => this.isReopenable(c) && this.selectedReopenKeys.includes(this.keyOf(c))
            );
        },
        // 선택 항목 중 대체평가(대체코드가 보완중으로 전환되는) 개수 — 모달 안내용
        selectedSubstituteCount() {
            return this.selectedReopenTargets.filter(c => c.priority).length;
        },
        show_ai_request_btn() {
            return this.is_admin >= 3 && (checkAppEnv() === 'hmc' || checkAppEnv() === 'ksteel' || checkAppEnv() === 'supply');
        },
        scoreCategory1() {
            return ['인권', '환경', '거버넌스'];
        },
        // 표 열 수 — 로딩 · 빈 결과 행의 칸 수가 머리와 같아야 고정 폭 표(ds-table-fixed)에 빈 열이 생기지 않는다
        table_col_count() {
            return 5 + this.scoreCategory1.length + (this.is_admin >= 3 ? 2 : 0) + (this.is_printing ? 0 : 1)
                + (this.is_admin === 4 && !this.is_printing ? 1 : 0); // 보완중 전환 고르기 열
        },
        scoreMapCategory1() {
            return {
                '인권': 'A. 인권',
                '환경': 'B. 환경',
                '거버넌스': 'C. 거버넌스'
            };
        },
        // 관리 모달 v1/v2 선택 — 판정은 report-template.js 단일 소스 (종전 로컬 IS_KSTEEL/IS_SUPPLY 재구현 대체)
        report_management_version(){
            const template = resolveReportTemplate({
                rendererKey: this.report_managing_company?.report_renderer_key,
                campaignId: this.report_managing_company?.campaign_id,
                fallbackRenderer: tenant && tenant.defaultRenderer,
            });
            return template != null && REPORT_RENDERERS[template].management === 'v2' ? 'v2' : 'v1';
        },
    },
    async created() {
        // if (this.$route.query.project) {
        //     await this.readAuditCompletedList()
        // }

        await this.getCompaniesAssessmentResult(true);
        // 팩트 배치 현황은 부가 정보라 결과 로딩과 분리해 비차단으로 조회한다(실패해도 화면 정상).
        this.loadProjectFactBatchStatus();
    },
    beforeDestroy() {
        this.update_is_history_score_loaded(false);
    },
    methods: {
        checkAppEnv,
        ...mapMutations('score', ['add_all_temp_target_companies', 'update_company']),
        ...mapActions('industry_campaigns', ['readHistoryScores', 'distributeCompanyReport', 'readNiceServiceStatus', 'readSingleCampaignTargetCompanies']),
        ...mapMutations('industry_campaigns', ['update_is_history_score_loaded', 'update_nice_service_status_loaded']),
        ...mapActions('industry_scores', ['readCompanyInfo', 'readIndustryInfo', 'readQeCrRisks', 'readQeCrScores', 'readAssessmentInfo', 'readQeCrFactors', 'readMateriality', 'readAuditReview', 'getFigureBenchmark', 'checkTaxonomyAccepted', 'readScoreHistory']),
        ...mapMutations('industry_scores', ['reset_industry_scores']),
        ...mapActions('reviews', ['readConclusionbyCompany', 'readRecommendationsbyCompany', 'initiateReviews']),
        ...mapActions('project_code', ['readProjectCompaniesCampaigns']),
        ...mapMutations('project_code', ['update_now_project']),
        ...mapMutations('attachments', ['initAttachmentsStorage']),
        ...mapActions('attachments', ['getAttatchments']),
        ...mapActions('admin', ['setLayoutLoading',]),
        toggleScroll(toggle) {
            if (toggle) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }
        },
        openManagingCompanyReportModal(_data) {
            // const no_rating = typeof this.now_project.no_rating === 'undefined' ? this.no_rating : this.now_project.no_rating
            const {
                project_code, campaign_id, campaign_name, period, request_id, audit_status,
                company_id, company_name, requested_e_mail, service_type, status_code,
                priority, report_renderer_key, template_code
            } = _data;

            this.report_managing_company = {
                project_code, campaign_id, campaign_name, period, request_id, audit_status,
                company_id, company_name, requested_e_mail, service_type, status_code,
                priority, report_renderer_key, template_code
            };

            this.$bvModal.show('managing-report');
        },
        async getCompaniesAssessmentResult(_need_loading = false) {
            try {
                if (_need_loading) {
                    this.is_loaded_companies_result = false;
                }
                this.results_error = '';
                const {pc, cmp, project_code, campaign_id, admin_mode} = this.$route.query;
                const params = {
                    project_code: pc ?? project_code,
                    campaign_id: cmp ?? campaign_id
                };
                if (admin_mode === 'project') {
                    delete params.campaign_id;
                }
                if (admin_mode === 'camp') {
                    delete params.project_code;
                }

                const _res_project_assessment_result = await this.$axios.get('/assessments/results', {
                    params
                });

                this.companiesResults = this.sortingCompanies(_res_project_assessment_result.data, {data: {is_loading: false}});
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.results_error = getErrorMessage(error, '평가결과를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
            } finally {
                if (_need_loading) {
                    this.is_loaded_companies_result = true;
                }
            }
        },
        async submitAnswerByQesg(company) {
            if (this.is_force_submitting) return false;
            company = company.priority ? company.priority : company;
            // 제출 확인과 안내 메일 발송 여부를 한 번에 받는다 (취소는 항상 전체 취소)
            this.force_submit_noti = false;
            const h = this.$createElement;
            const _confirm_force_submit = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '임의 제출',
                message: h('div', {}, [
                    h('div', {}, `"${company.company_name}"의 답변을 임의 제출 하시겠습니까?`),
                    h('label', {class: 'd-block mt-3 mb-0'}, [
                        h('input', {
                            attrs: {type: 'checkbox'},
                            class: 'mr-2',
                            on: {change: (ev) => { this.force_submit_noti = ev.target.checked; }}
                        }),
                        '기업에게 평가 제출 안내 메일도 발송'
                    ])
                ])
            });
            if (!_confirm_force_submit) {
                return false;
            }

            try {
                this.is_force_submitting = true;
                const {company_id, campaign_id, project_code} = company;

                await this.$axios.put('/company/submit', {
                    data: {
                        campaign_id, company_id, project_code,
                        is_force_sumit: true,
                        is_force_submit_noti: this.force_submit_noti
                    }
                });
                this.$EventBus.$emit('toast-success', '임의 제출', `${company.company_name}의 답변을 임의 제출 하였습니다.`);
            } catch (error) {
                console.log(error);
                this.$EventBus.$emit('toast-failure', '임의 제출 실패', getErrorMessage(error, '임의 제출 중 오류가 발생했습니다. 개발팀에 문의해주세요.'));
            } finally {
                this.is_force_submitting = false;
                await this.getCompaniesAssessmentResult();
            }
        },
        async updateServiceType(company) {
            let as_is_status = company.priority ? company.priority.service_type : company.service_type;
            let to_be_status = as_is_status == '일반' ? '심화' : '일반';

            let confirm_msg = company.priority ? `[대체평가, ${company.priority.project_code}]` : '';
            confirm_msg += `"${company.priority ? company.priority.company_name : company.company_name}"`;
            confirm_msg += `기업의 평가유형을 "${as_is_status}"에서 "${to_be_status}" 으로 변경하시겠습니까?`;

            let is_confirm_updating_service_type = await this.$showModal({
                type: 'confirm', state: 'warning', title: '평가유형 변경', message: confirm_msg
            });
            if (is_confirm_updating_service_type) {
                this.is_service_types_updating = company.company_id;
                try {
                    const company_id = company.priority ? company.priority.company_id : company.company_id;
                    const campaign_id = company.priority ? company.priority.campaign_id : company.campaign_id;
                    const project_code = company.priority ? company.priority.project_code : company.project_code;

                    const res_update_service_type = await this.$axios.put('/assessments/service_type', {
                        company_id, campaign_id, project_code, service_type: to_be_status
                    });

                    const _warnings = res_update_service_type.data.warnings;
                    if (_warnings && _warnings.length) {
                        alert(_warnings.join('\n'));
                    }

                    // 표는 검색으로 걸러져 있을 수 있어 행 위치를 company_id 로 다시 찾는다
                    const company_idx = this.companiesResults.findIndex(c => c.company_id === company.company_id);
                    if (company_idx > -1) {
                        let _company_record = Object.assign({}, {...this.companiesResults[company_idx]});
                        if (company.priority) {
                            _company_record['priority']['service_type'] = res_update_service_type.data.service_type;
                        } else {
                            _company_record['service_type'] = res_update_service_type.data.service_type;
                        }

                        this.$set(this.companiesResults, company_idx, _company_record);
                    }
                } catch (error) {
                    if (error?.response?.status === 401) return;
                    // 서버가 보낸 사유를 우선 표시, 없으면 일반 문구
                    this.$EventBus.$emit('toast-failure', '평가유형 변경 실패', getErrorMessage(error, '죄송합니다. 평가유형 변경도중 장애가 발생했습니다. 개발팀에 문의주세요.'));
                } finally {
                    this.is_service_types_updating = null;
                    await this.getCompaniesAssessmentResult();
                }
            }
        },
        async goCompanyAnswers(_company) {
            const project_code = _company.priority ? _company.priority.project_code : _company.project_code;
            const campaign_id = _company.priority ? _company.priority.campaign_id : _company.campaign_id;
            const company_id = _company.priority ? _company.priority.company_id : _company.company_id;
            const company_name = _company.priority ? _company.priority.company_name : _company.company_name;
            const template_code = _company.priority ? _company.priority.template_code : _company.template_code;
            const {client, campaign_name} = this.$route.query;

            if (this.admin_mode === 'project') {
                this.$router.push({
                    name: 'CompanyAnswers',
                    params: {company_id},
                    query: {
                        client,
                        pc: project_code,
                        cmp: campaign_id,
                        cpn: company_id,
                        cpnm: company_name,
                        template_code,
                        admin_mode: this.admin_mode
                    }
                });
            }
            if (this.admin_mode === 'camp') {
                this.$router.push({
                    name: 'CompanyAnswers',
                    params: {company_id},
                    query: {
                        campaign_name,
                        pc: project_code,
                        cmp: campaign_id,
                        cpn: company_id,
                        cpnm: company_name,
                        template_code,
                        admin_mode: this.admin_mode
                    }
                });
            }
        },
        async showReport(item, code, idx) {
            try {
                this.companiesResults[idx]['is_loading'] = true;
                let _modal_name = `${code}-report`;
                this.isReportGenerating[code] = true;
                this.setReportMode(item, code);
                this.company_status = item.status_code;

                const _res_report_data = await this.$axios('/report/data', {
                    params: {
                        campaign_id: !item.priority ? item.campaign_id : item.priority.campaign_id,
                        project_code: !item.priority ? item.project_code : item.priority.project_code,
                        company_id: !item.priority ? item.company_id : item.priority.company_id,
                    }
                });

                const _report_data = _res_report_data.data;
                this.reportData = {
                    info: _report_data.info,
                    benchmarks: _report_data.benchmarks,
                    parser: _report_data.parser_result,
                    risk: _report_data.risk,
                    scoring: _report_data.scoring
                };

                this.$nextTick(() => {
                    this.$bvModal.show(`${_modal_name}-modal`);
                });
            } catch (error) {
                if (error.response) {
                    console.log(' ~ error.response => ', error.response);
                }

                this.common_error_handling(error);
            } finally {
                this.isReportGenerating[code] = false;
                this.companiesResults[idx]['is_loading'] = false;
            }
        },
        setReportMode(company, code) {
            this.no_rating = typeof this.now_project.no_rating === 'undefined' ? this.no_rating : this.now_project.no_rating;
            this.result_report_mode = code;
            let data_quality = '';

            const _service_type = company.priority ? company.priority.service_type : company.service_type;
            if (_service_type == '심화') {
                data_quality = 'Lv3. 현장평가';
            } else {
                if (this.now_project.self_assessment == false) {
                    data_quality = 'Lv2. 서면평가';
                } else {
                    data_quality = 'Lv1. 자가진단';
                }
            }

            let new_project = {
                project_code: this.now_project.project_code,
                manager: this.now_project.manager,
                client: this.now_project.client,
                by_nice: company.by_nice,
                data_quality: data_quality,
                self_assessment: this.now_project.self_assessment
            };

            this.update_now_project(new_project);
        },
        initiateReportContents() {
            this.reset_industry_scores(true);
            this.report_summary = false;
        },
        // 보완중 전환 '선택 가능' 여부 — 대상 기준 통일: 실제 바꾸는 대상(대체평가가
        // 있으면 대체 B, 없으면 A)의 상태가 평가중/완료일 때만 선택 가능. 이렇게 하면
        // effectiveIdent(전송 대상)와 선택 기준이 일치해 '체크=전환'이 보장된다.
        isReopenable(company) {
            const target = company.priority ? company.priority : company;
            return ['in_assessment', 'completed'].includes(target.status_code);
        },
        // 대체평가(priority)가 있으면 그 식별자를 우선한다 (단건 backToInProgress 와 동일).
        effectiveIdent(company) {
            const src = company.priority ? company.priority : company;
            return {
                project_code: src.project_code,
                campaign_id: src.campaign_id,
                company_id: src.company_id,
            };
        },
        keyOf(company) {
            const id = this.effectiveIdent(company);
            return `${id.project_code}|${id.campaign_id}|${id.company_id}`;
        },
        // 행 더보기 메뉴의 임의제출 · 답변수정 노출 조건 — 예전 상태변경 칸 그대로(원래 · 대체 어느 쪽이든 해당하면)
        canForceSubmit(company) {
            return company.status_code === 'in_progress' || !!(company.priority && company.priority.status_code === 'in_progress');
        },
        canEditAnswer(company) {
            return ['in_assessment', 'completed'].includes(company.status_code)
                || !!(company.priority && ['in_assessment', 'completed'].includes(company.priority.status_code));
        },
        toggleSelectAllReopen(checked) {
            const keys = this.reopenableKeys;
            this.selectedReopenKeys = checked
                ? [...new Set([...this.selectedReopenKeys, ...keys])]
                : this.selectedReopenKeys.filter(k => !keys.includes(k));
        },
        // 모달 [전환] 확정 시 실행 — 선택된 업체들을 일괄 '보완중'으로 전환
        // (POST /company/answers/reopen-bulk). 사전 확인은 확인 모달이 담당한다.
        async performBulkReopen() {
            const selected = this.selectedReopenTargets;
            if (selected.length === 0) {
                return;
            }

            const items = selected.map(c => this.effectiveIdent(c));

            this.is_bulk_reopening = true;
            try {
                const {data} = await this.$axios.post('/company/answers/reopen-bulk', {items});
                const reopened = (data && data.reopened) ? data.reopened.length : 0;
                const skipped = (data && data.skipped) ? data.skipped.length : 0;
                if (skipped > 0) {
                    this.$EventBus.$emit('toast-success', '보완중 전환 완료',
                        `${reopened}개 업체를 보완중으로 전환했습니다. (${skipped}개는 대상 상태가 아니어서 건너뜀)`);
                } else {
                    this.$EventBus.$emit('toast-success', '보완중 전환 완료',
                        `${reopened}개 업체를 보완중으로 전환했습니다.`);
                }
                this.selectedReopenKeys = [];
            } catch (error) {
                if (error.response) {
                    console.log(' ~ performBulkReopen error.response => ', error.response);
                }
                this.$EventBus.$emit('toast-failure', '보완중 전환 실패',
                    '선택 업체 보완중 전환 중 장애가 발생했습니다. 개발팀에 문의해주세요.');
            } finally {
                this.is_bulk_reopening = false;
                await this.getCompaniesAssessmentResult();
            }
        },
        async backToInProgress(company) {
            // 대체평가가 있으면 대체 레코드를 되돌린다 (일괄 전환 effectiveIdent 와 같은 기준)
            const {project_code, company_id, company_name, campaign_id} = company.priority || company;
            const h = this.$createElement;
            const check = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '답변 가능 상태로 변경',
                message: h('div', {}, [
                    h('div', {}, `"${company.priority ? '[대체평가] ' : ''}${company_name}"를 답변 가능한 상태로 변경하시겠습니까?`),
                    h('div', {class: 'text-danger small mt-2'}, '변경하면 해당 업체의 모든 문항이 다시 답변 가능(재작성) 상태가 됩니다.'),
                ]),
            });
            if (!check) {
                return false;
            }

            try {
                const response = await this.$axios.put('/company/submit/cancel', {
                    project_code, company_id, campaign_id
                });

                if (response.data.code !== 'success') {
                    this.$EventBus.$emit('toast-failure', '상태 변경 실패', response.data.msg || `${company_name} 를 답변 가능한 상태로 바꾸지 못했습니다.`);
                } else {
                    this.$EventBus.$emit('toast-success', '상태 변경 완료', `${company_name} 를 답변 가능한 상태로 변환하였습니다.`);
                }
            } catch (error) {
                if (error?.response?.status === 401) return;
                if (error.response) {
                    const {status, data} = error.response;
                    if (status === 404 && data?.message === 'Not_Found_Assessment_Request') {
                        this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company_name}의 평가신청 이력을 찾을 수 없습니다. 개발팀에 문의해주세요.`);
                    } else if (status === 400 && data?.message === 'Not_Status_Change') {
                        this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company_name} 가 답변 가능한 상태로 변경할 수 없는 상태입니다. 개발팀에 문의해주세요.`);
                    } else {
                        this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company_name} 를 답변 가능한 상태로 변환 중 장애가 발생했습니다. 개발팀에 문의해주세요.`);
                    }
                } else {
                    this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company_name} 를 답변 가능한 상태로 변환 중 장애가 발생했습니다. 개발팀에 문의해주세요.`);
                }
            } finally {
                await this.getCompaniesAssessmentResult();
            }
        },
        async downloadEvaluationPacket(company) {
            // 기업 1개의 AI 평가용 자료(문항별 JSON + 답변 첨부파일)를 ZIP으로 다운로드한다.
            // 평가자가 이 ZIP을 외부 AI에 넣어 오프라인 평가하는 워크플로우의 입력물.
            //
            // 2단계 흐름(브라우저 네이티브 다운로드 = 다운로드 바 + 진행상황):
            //   1) 서명 URL 발급 요청(axios, Bearer 인증) → 짧은 수명 토큰
            //   2) window.location 으로 토큰 URL 이동 → 브라우저가 직접 스트리밍 저장
            // axios blob 방식은 파일 전체를 JS 메모리에 받은 뒤 저장해 네이티브 진행상황이
            // 안 뜨므로 사용하지 않는다. 브라우저 직접 이동은 Authorization 헤더를 못 실어
            // 서명 토큰(URL 자체 인증)이 필요하다.
            //
            // 답변보기(goCompanyAnswers)와 동일하게 대체(priority) 레코드를 우선한다.
            const campaign_id = company.priority ? company.priority.campaign_id : company.campaign_id;
            const company_id = company.priority ? company.priority.company_id : company.company_id;
            const company_name = company.priority ? company.priority.company_name : company.company_name;

            if (this.downloading_packet_id) return; // 다른 행이 진행 중이면 무시(중복 클릭 방지)
            // 스피너/비활성화는 행 식별용 base company_id 기준 (대체 여부와 무관)
            this.downloading_packet_id = company.company_id;
            try {
                // 1) 서명 토큰 발급 (Bearer 인증은 axios 인터셉터가 부착)
                const {data} = await this.$axios.get('/assessments/evaluation-packet/download-url', {
                    params: {campaign_id, company_id}
                });
                // 2) 토큰 URL로 브라우저 직접 이동 → 네이티브 다운로드(진행상황 표시).
                //    파일명은 백엔드 Content-Disposition(top-level 이동이라 브라우저가 읽음)이 결정.
                const base = process.env.VUE_APP_BACKENDHOST; // 예: https://.../api
                const url = `${base}/assessments/evaluation-packet/download?token=${encodeURIComponent(data.token)}`;
                window.location.href = url;
            } catch (error) {
                console.log(' ~ downloadEvaluationPacket error => ', error);
                if (error.response) {
                    console.log(' ~ error.response => ', error.response);
                }
                this.$EventBus.$emit('toast-failure', 'AI 평가용 자료 다운로드 실패', `${company_name} AI 평가용 자료 다운로드에 실패했습니다. 개발팀에 문의해주세요.`);
            } finally {
                this.downloading_packet_id = null;
            }
        },
        async downloadAnswerAggregationsByCompany({company_id, campaign_id, company_name, project_code: company_project_code}) {
            const project_code = this.now_project.project_code || company_project_code;
            try {
                const response = await this.$axios.get('/parser/values/excel', {
                    params: {
                        project_code,
                        company_id, campaign_id,
                        type: 'Figure'
                    },
                    responseType: 'blob'
                });

                this.downloadFileFromResponse(response, `${project_code}_${company_name}_${company_id}_답변_집계값.xlsx`);
                alert(`${company_name}(${company_id})의 답변 집계 데이터 다운로드를 완료하였습니다!`);
            } catch (error) {
                console.log(' ~ error => ', error);
                if (error.response) {
                    console.log(' ~ error.response => ', error.response);
                }
                alert(`${company_name}(${company_id})의 답변 집계 데이터 다운로드를 실패하였습니다. 개발팀에 문의해주세요!`);
            } finally {
                await this.getCompaniesAssessmentResult();
            }
        },
        roundToOneDecimalPlace(value) {
            if(value == null) return ' - ';
            return Math.round(value * 10) / 10;
        },
        goSupplementReview(company) {
            // AI 보완검토 화면을 새 탭으로 연다 (업체별 자료보완 필요 판정 + 보완요청 메일 초안).
            // 답변보기/다운로드와 동일하게 대체(priority) 레코드를 우선한다.
            const campaign_id = company.priority ? company.priority.campaign_id : company.campaign_id;
            const company_id = company.priority ? company.priority.company_id : company.company_id;
            const route = this.$router.resolve({
                name: 'ManagingSupplementReview',
                query: {campaign_id, company_id},
            });
            window.open(route.href, '_blank', 'noopener');
        },
        goEvalProfileManagement() {
            // AI 평가 프로파일 관리 화면을 새 탭으로 연다 (질문지별 평가 기준 등록/연결).
            // 보고서 작업 흐름을 잃지 않도록 같은 탭 이동 대신 새 탭으로 띄운다.
            const route = this.$router.resolve({ name: 'ManagingEvalProfiles' });
            window.open(route.href, '_blank', 'noopener');
        },
        aiJudgmentModeLabel(mode) {
            return mode === 'batch' ? '배치' : '즉시';
        },
        aiJudgmentModeNotice(mode) {
            return mode === 'batch'
                ? '벤더 배치(지연·최대 24시간·50% 할인)로 처리됩니다.'
                : '지금 바로 처리됩니다(즉시).';
        },
        async checkRequestProjectAIAssessment(mode) {
            // 서버가 dry_run 으로 센 건수를 확인받고 그 건수(confirm_expected)로만 발행한다.
            // pageLoading 은 회사별 AI 요청/충돌 확인 등 형제 플로우와 공유되는 전체 로딩 상태이므로,
            // 다른 작업이 진행 중일 때도 일괄 요청 진입을 막는다. 플래그는 모달이 떠 있는 동안에도 유지해 연타를 막는다.
            if (this.is_bulk_ai_requesting || this.pageLoading) {
                return;
            }
            const project_code = this.now_project?.project_code
                || this.$route.query.pc
                || this.$route.query.project_code;
            if (!project_code) {
                this.$EventBus.$emit('toast-failure', 'AI 평가 일괄 요청 실패', '프로젝트 정보를 찾을 수 없습니다. 페이지를 새로고침한 후 다시 시도해주세요.');
                return;
            }

            this.is_bulk_ai_requesting = true;
            let accepted = false;
            try {
                const result = await runConfirmedDispatch({
                    post: payload => this.postProjectAIAudit(payload),
                    body: {project_code, judgment_mode: mode},
                    confirm: (expected, previous) => this.confirmProjectAIModal(mode, expected, previous),
                });
                if (result.outcome === 'empty') {
                    this.$EventBus.$emit('toast-warning', 'AI 평가 일괄 요청', '요청할 대상이 없습니다.');
                } else if (result.outcome === 'accepted') {
                    accepted = true;
                    const {data} = result;
                    if (data?.published === false) {
                        this.$EventBus.$emit('toast-warning', 'AI 평가 일괄 요청 발행 실패',
                            `${data?.expected ?? 0}건 요청은 접수됐지만 처리 작업을 시작하지 못했습니다. 개발팀에 문의해주세요.`);
                    } else {
                        this.$EventBus.$emit('toast-success', 'AI 평가 일괄 요청 접수',
                            `${data?.expected ?? 0}건 요청을 접수했습니다. 결과는 처리 후 새로고침으로 확인하세요.`);
                    }
                }
            } catch (error) {
                console.error('AI 평가 일괄 요청 중 오류 발생:', error);
                this.$EventBus.$emit('toast-failure', 'AI 평가 일괄 요청 실패', this.projectAIAuditErrorMessage(error));
            } finally {
                this.is_bulk_ai_requesting = false;
            }

            if (accepted) {
                // 평가지 상태가 '평가중' 등으로 바뀌므로 목록을 새로고침한다.
                await this.withPageLoading({title: '목록 새로고침 중', content: '잠시만 기다려주세요...'},
                    () => this.getCompaniesAssessmentResult());
            }
        },
        postProjectAIAudit(payload) {
            const loadingMsg = payload.dry_run
                ? {title: 'AI 평가 대상 확인 중', content: '요청할 문항 수를 세고 있습니다...'}
                : {title: 'AI 평가 일괄 요청 중', content: '잠시만 기다려주세요...'};
            return this.withPageLoading(loadingMsg,
                async () => (await this.$axios.post('/assessments/ai-audit/project', payload)).data);
        },
        async withPageLoading(loadingMsg, fn) {
            this.loadingMsg = loadingMsg;
            this.pageLoading = true;
            this.toggleScroll(true);
            try {
                return await fn();
            } finally {
                this.toggleScroll(false);
                this.pageLoading = false;
            }
        },
        confirmProjectAIModal(mode, expected, previous) {
            const h = this.$createElement;
            return this.$showModal({
                type: 'confirm',
                state: previous == null ? 'info' : 'warning',
                title: `AI 평가 일괄 요청 (${this.aiJudgmentModeLabel(mode)})`,
                message: h('div', {}, [
                    previous != null && h('div', { class: 'text-danger mb-2' },
                        `요청하는 사이 대상 건수가 바뀌었습니다 (약 ${previous}건 → 약 ${expected}건). 바뀐 건수로 다시 확인해주세요.`),
                    h('div', {}, `현재 프로젝트의 평가 문항 약 ${expected}건을 AI 평가 요청합니다.`),
                    // 프로젝트 요청은 캠페인과 달리 '없거나 실패한 것만'을 고르지 않는다(백엔드 계약).
                    h('div', { class: 'text-danger small mt-2' },
                        '이미 AI 평가가 끝난 문항도 포함해 전부 다시 평가하므로 그만큼 비용이 발생합니다.'),
                    h('div', { class: 'text-muted small mt-2' }, this.aiJudgmentModeNotice(mode)),
                    h('div', { class: 'text-muted small mt-2' },
                        '연결된 평가 프로파일이 없는 질문지는 시스템 기본 평가 기준으로 평가됩니다.'),
                ]),
            });
        },
        projectAIAuditErrorMessage(error) {
            const status = error?.response?.status;
            if (status === 403) return 'AI 평가 일괄 요청 권한이 없습니다.';
            if (status === 404) return '프로젝트를 찾을 수 없습니다. 페이지를 새로고침한 후 다시 시도해주세요.';
            if (status === 400) return '요청 형식이 올바르지 않습니다. 개발팀에 문의해주세요.';
            // 헬퍼가 던진 오류(구 백엔드 차단 등)만 문구를 그대로 쓴다. 통신 오류(axios)는 기본 문구로.
            if (!error?.isAxiosError && error?.message) return error.message;
            return 'AI 평가 일괄 요청 중 오류가 발생했습니다. 개발팀에 문의해주세요.';
        },
        async loadProjectFactBatchStatus() {
            // 진입 시 1회 + 수동 새로고침. 프로젝트 모드에서만 의미가 있다.
            const projectCode = this.$route.query.pc
                || this.now_project?.project_code
                || this.$route.query.project_code;
            if (!projectCode || this.admin_mode !== 'project') {
                return;
            }
            // 중첩 조회(진입 조회 + 요청 후 재조회)에서 오래된 응답이 최신을 덮어쓰지 않도록
            // 요청 토큰을 두고, 마지막 요청의 응답만 반영한다(코드리뷰 #4).
            const reqToken = (this._factStatusReq = (this._factStatusReq || 0) + 1);
            this.factStatusLoading = true;
            try {
                // { project_code, companies, total, done, failed, queued, in_progress, pending }
                const { data } = await this.$axios.get('/document-facts/batch/project-status', {
                    params: { project_code: projectCode },
                });
                if (reqToken === this._factStatusReq) {
                    this.factBatchStatus = data;
                }
            } catch (error) {
                // 부가 정보라 실패해도 화면을 막지 않는다(배지만 안 뜸).
                console.warn('팩트 배치 현황 조회 실패:', error);
            } finally {
                if (reqToken === this._factStatusReq) {
                    this.factStatusLoading = false;
                }
            }
        },
        checkRequestProjectFactBatch() {
            // AI 평가 일괄 요청과 동일 패턴: 모달 연타/형제 플로우 점유를 진입 전에 막는다.
            if (this.is_fact_batch_requesting || this.pageLoading) {
                return;
            }
            const h = this.$createElement;
            this.$showModal({
                type: 'confirm',
                state: 'info',
                title: '팩트 일괄 추출',
                message: h('div', {}, [
                    h('div', {}, '현재 프로젝트에 속한 모든 업체의 아직 추출되지 않은 첨부를 배치로 일괄 추출하시겠습니까?'),
                    h('div', { class: 'text-muted small mt-2' },
                        '벤더 배치(지연·최대 24시간·50% 할인)로 처리되며, 이미 추출됐거나 진행 중인 첨부는 자동으로 제외됩니다.'),
                ]),
            })
                .then((value) => {
                    if (value) {
                        this.requestProjectFactBatch();
                    }
                });
        },
        async requestProjectFactBatch() {
            if (this.is_fact_batch_requesting || this.pageLoading) {
                return;
            }

            const project_code = this.now_project?.project_code
                || this.$route.query.pc
                || this.$route.query.project_code;

            if (!project_code) {
                this.$EventBus.$emit('toast-failure', '팩트 일괄 추출 실패', '프로젝트 정보를 찾을 수 없습니다. 페이지를 새로고침한 후 다시 시도해주세요.');
                return;
            }

            this.is_fact_batch_requesting = true;
            this.loadingMsg = {
                title: '팩트 일괄 추출 요청 중',
                content: '잠시만 기다려주세요...'
            };
            this.pageLoading = true;
            this.toggleScroll(true);

            try {
                // 응답: { mode, project_code, companies, queued, already_extracted, already_queued, errors[] }
                // (AI 평가와 달리 실패는 errors 배열 길이로 판정한다.)
                const { data } = await this.$axios.post('/document-facts/extract/project', {
                    project_code
                });

                const companies = Number(data?.companies) || 0;
                const queued = Number(data?.queued) || 0;
                const extracted = Number(data?.already_extracted) || 0;
                const active = Number(data?.already_queued) || 0;
                const errCount = Array.isArray(data?.errors) ? data.errors.length : 0;

                const summary = `업체 ${companies}개 대상 · 새로 ${queued}건 접수`
                    + (extracted ? ` · 이미 추출 ${extracted}건 제외` : '')
                    + (active ? ` · 진행 중 ${active}건 제외` : '');

                if (errCount > 0) {
                    this.$EventBus.$emit('toast-failure', '팩트 일괄 추출 부분 실패',
                        `${summary} · 일부 업체 처리 실패 ${errCount}건. 잠시 후 다시 시도해주세요.`);
                } else {
                    this.$EventBus.$emit('toast-success', '팩트 일괄 추출 접수',
                        `${summary}. 완료까지 최대 24시간 걸릴 수 있으며, 문서 사실 추출 화면에서 진행 상황을 확인할 수 있습니다.`);
                }
            } catch (error) {
                console.error('팩트 일괄 추출 중 오류 발생:', error);
                this.$EventBus.$emit('toast-failure', '팩트 일괄 추출 실패', '팩트 일괄 추출 중 오류가 발생했습니다. 개발팀에 문의해주세요.');
            } finally {
                this.is_fact_batch_requesting = false;
                this.toggleScroll(false);
                this.pageLoading = false;
                // 방금 접수한 결과(대기 건수 증가 등)를 배지에 바로 반영한다.
                this.loadProjectFactBatchStatus();
            }
        },
        checkRequestAIAssessment(company, mode) {
            const h = this.$createElement;
            this.$showModal({
                type: 'confirm',
                state: 'info',
                title: `AI 평가 요청 (${this.aiJudgmentModeLabel(mode)})`,
                message: h('div', {}, [
                    h('div', {}, `기업 "${company.priority ? '[대체평가] ' : ''}${(company.priority || company).company_name}"에 대한 AI 평가를 요청하시겠습니까?`),
                    h('div', { class: 'text-muted small mt-2' }, this.aiJudgmentModeNotice(mode)),
                ]),
            })
                .then((value) => {
                    if (value) {
                        this.requestAIAssessment(company, mode);
                    }
                });

        },
        async requestAIAssessment(company, mode) {
            // 요청 대상(대체평가가 있으면 대체 레코드)의 상태로 판정한다
            const target = company.priority || company;
            let checkAvailable = true;
            if (target.manual_status === 'eco_vadis' || target.status_code === 'canceled' || target.status_code === 'requested' || target.status_code == null) {
                checkAvailable = false;
            } else if (target.status_code === 'in_progress' && !target.in_assessment_ts) {
                checkAvailable = false;
            }
            if (!checkAvailable) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('AI 평가 요청 실패'),
                    message: this.$t('AI 평가는 상태가 \'평가중\', \'보완중\', \'완료\'인 경우에만 요청할 수 있습니다.'),
                });

                return;
            }

            this.loadingMsg = {
                title: 'AI 평가 요청 중',
                content: '잠시만 기다려주세요...'
            };
            this.pageLoading = true;
            this.toggleScroll(true);

            try {
                const {company_id, campaign_id} = target;

                const _res_searched_ais = await this.$axios.get('/assessments/ai-audit/v2', {
                    params: {
                        company_id,
                        campaign_id,
                        order_by: 'created_at',
                        order_dir: 'desc',
                        page: 1,
                        per_page: 99999,
                    },
                });

                const {items} = _res_searched_ais.data;
                const waiting_ai_audits = items.filter((item) => {
                    const requested_at = item.updated_at ?? item.created_at;
                    return !checkCanRequestAi(item.status, requested_at);
                });

                if (waiting_ai_audits.length > 0) {
                    const h = this.$createElement;
                    this.$showModal({
                        type: 'alert',
                        state: 'warning',
                        title: this.$t('AI 평가 요청 실패'),
                        message: h('div', {}, [
                            h('div', {}, this.$t('AI 평가가 진행 중인 문항이 있습니다.')),
                            h('div', {}, this.$t('모든 문항의 AI 평가가 완료된 후에, 평가지에 대한 AI 평가를 요청할 수 있습니다.')),
                        ])
                    });
                    this.pageLoading = false;
                    this.toggleScroll(false);
                    return;
                }

                const response = await this.$axios.post('/assessments/ai-audit', {
                    company_id, campaign_id, judgment_mode: mode,
                });

                if (response.status === 201) {
                    this.$EventBus.$emit('toast-success', 'AI 평가 요청 완료', response.data.message);
                    return;
                }
                if (response.status === 202) {
                    this.$EventBus.$emit('toast-failure', 'AI 평가 요청 실패', response.data.message);
                }
            } catch (error) {
                console.error('AI 평가 요청 중 오류 발생:', error);
                this.$EventBus.$emit('toast-failure', 'AI 평가 요청 실패', 'AI 평가 요청 중 오류가 발생했습니다. 개발팀에 문의해주세요.');
            } finally {
                this.toggleScroll(false);
                this.pageLoading = false;
            }

        },
        // responseType blob 요청의 오류 본문(Blob)에서 사유를 읽는다
        async blobErrorMessage(error, fallback) {
            let data = error?.response?.data;
            if (data instanceof Blob) {
                const text = await data.text();
                try {
                    data = JSON.parse(text);
                } catch (e) {
                    data = text;
                }
            }
            return getErrorMessage({response: {data}}, fallback);
        },
        async checkIntegrity(useLoading = true) {
            const project_code = this.now_project.project_code || this.$route.query.pc;
            if (useLoading) {
                this.loadingMsg = {
                    title: '답변 충돌 확인 중',
                    content: '잠시만 기다려주세요...'
                };
                this.pageLoading = true;
            }
            try {
                const response = await this.$axios.get('/v2/scoring/check-integrity', {
                    params: {
                        project_code,
                    },
                    responseType: 'blob'
                });

                if (response.status === 200) {
                    this.$showModal({
                        type: 'alert',
                        state: 'info',
                        title: '답변 충돌 확인 완료',
                        message: '충돌되는 답변이 있습니다. 다운로드된 엑셀을 확인해주세요.'
                    });
                    this.downloadFileFromResponse(response, `${project_code}_답변_충돌_데이터`);

                } else if (response.status === 204) {
                    this.$EventBus.$emit('toast-success', '답변 충돌 확인 완료', '충돌되는 답변이 없습니다.');
                }
            } catch (e) {
                if (e?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '답변 충돌 확인 실패',
                    await this.blobErrorMessage(e, '충돌 확인 중 오류가 발생했습니다. 개발팀에 문의해주세요.'));
            } finally {
                this.pageLoading = false;
                // 데이터 센터 모달을 연 적이 없거나 닫혀 있으면 ref 가 없다
                if (this.$refs.projectDataCenterRef) {
                    this.$refs.projectDataCenterRef.loadingCheckIntegrity = false;
                }
            }
        }
    },
};
</script>

<style>
.report-modal-body {
    padding: 1rem !important;
}

.blue-bottom {
    border-bottom: 1px solid var(--blue);
    color: var(--blue);
}

.dropdown-simple > .btn-icon-dark {
    text-align: left;
    font-size: 0.95rem;
    padding: 0.3rem;
    overflow: hidden;
}

.dropdown-simple > .dropdown-toggle::after {
    margin-top: 0.5rem;
    float: right;
    border-top: 0.5em solid !important;
    border-right: 0.45em solid transparent !important;
    border-bottom: 0;
    border-left: 0.45em solid transparent !important;
}

.report-chart {
    max-height: 240px;
    width: 90%;
}

/* 평가결과 표 — 폭을 안 적은 기업 · 프로젝트 열이 각 140 아래로 좁아지면 가로 스크롤(고정 열 합 828 + 140x2).
   본문이 고정폭(b-container, 최대 1110~1338)이라 이보다 넓게 잡으면 늘 가로 스크롤이 생긴다.
   인쇄 때는 종이 폭에 맞추고 줄임을 풀어 전체 글을 보인다 */
.campaign-report-table {
    min-width: 1100px;
}

.campaign-report-table.is-printing {
    min-width: 0;
}

.campaign-report-table.is-printing .ds-ellipsis {
    white-space: normal;
}

/* 상단 바(원청 셸 --ds-shell-header-h: 48 · 휴대폰 88) 아래만 덮는다 */
.dimmed-loading {
    position: fixed;
    top: var(--ds-shell-header-h, 48px);
    height: calc(100dvh - var(--ds-shell-header-h, 48px));
    width: 100vw;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
}
</style>
